export const SECOND_STEP_TEXT = 'Second Step'
export const NOTIFY_ADMINS_TEXT_HEADER = 'Admins will be notified'
export const NOTIFY_ADMINS_TEXT_BODY = `Adding Second Step® admins will grant them access to your school’s
            Second Step® programs and features. We’ll send them an email
            notification to let them know.`
export const NOTIFY_USERS_TEXT_HEADER = 'Send email notification?'
export const NOTIFY_USERS_TEXT_BODY =
  "Adding users will grant them access to your school's Second Step® programs. You can notify them of access now or wait until you're ready."
export const FAQ_LINK = ' See the FAQ on email notifications.'
export const NOTIFY_RADIO_LABEL_TRUE = 'Yes, send emails now'
export const NOTIFY_RADIO_LABEL_FALSE = "No, we'll do this later"
export const FAQ_LINK_URL =
  'https://support.secondstep.org/hc/en-us/articles/360017384794-I-am-a-license-administrator-What-does-that-mean-'



// WEBPACK FOOTER //
// ./src/components/AddUserSendNotification/constants.js